import { combineReducers } from 'redux'
import initialState from '../Store';
 import Survey from './r.survey'

const appReducer = combineReducers({
    Survey
})

const rootReducer = (state, action) =>
{
    if (action.type === 'STORE_RESET')
    {
        state = initialState;
    }

    return appReducer(state, action);
}

export default rootReducer


// WEBPACK FOOTER //
// ./src/Reducers/index.jsx